import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71338da3"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "send_mail_modal",
  "data-toggle": "modal"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "send_mail_modal_label"
  }, " Select recipients "),
  /*#__PURE__*/_createElementVNode("div", {
    class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" })
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Recipients", -1))
const _hoisted_6 = { class: "d-flex justify-content-center align-items-center w-100 mb-5" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "More recipients", -1))
const _hoisted_8 = { class: "d-flex justify-content-between align-items-center mb-2" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  version: "1.1",
  viewBox: "0 0 24 24",
  height: "24px",
  width: "24px",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "Oval-5",
    fill: "#000000",
    opacity: "0.3",
    cx: "12",
    cy: "12",
    r: "10"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M11,11 L11,7 C11,6.44771525 11.4477153,6 12,6 C12.5522847,6 13,6.44771525 13,7 L13,11 L17,11 C17.5522847,11 18,11.4477153 18,12 C18,12.5522847 17.5522847,13 17,13 L13,13 L13,17 C13,17.5522847 12.5522847,18 12,18 C11.4477153,18 11,17.5522847 11,17 L11,13 L7,13 C6.44771525,13 6,12.5522847 6,12 C6,11.4477153 6.44771525,11 7,11 L11,11 Z",
    id: "Combined-Shape",
    fill: "#000000"
  })
], -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-danger svg-icon-2x" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    version: "1.1"
  }, [
    /*#__PURE__*/_createElementVNode("g", {
      stroke: "none",
      "stroke-width": "1",
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      /*#__PURE__*/_createElementVNode("rect", {
        x: "0",
        y: "0",
        width: "24",
        height: "24"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M6,8 L18,8 L17.106535,19.6150447 C17.04642,20.3965405 16.3947578,21 15.6109533,21 L8.38904671,21 C7.60524225,21 6.95358004,20.3965405 6.89346498,19.6150447 L6,8 Z M8,10 L8.45438229,14.0894406 L15.5517885,14.0339036 L16,10 L8,10 Z",
        fill: "#000000",
        "fill-rule": "nonzero"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M14,4.5 L14,3.5 C14,3.22385763 13.7761424,3 13.5,3 L10.5,3 C10.2238576,3 10,3.22385763 10,3.5 L10,4.5 L5.5,4.5 C5.22385763,4.5 5,4.72385763 5,5 L5,5.5 C5,5.77614237 5.22385763,6 5.5,6 L18.5,6 C18.7761424,6 19,5.77614237 19,5.5 L19,5 C19,4.72385763 18.7761424,4.5 18.5,4.5 L14,4.5 Z",
        fill: "#000000",
        opacity: "0.3"
      })
    ])
  ])
], -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 0,
  class: "text-danger fs-6"
}
const _hoisted_16 = { class: "modal-footer" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Send ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_MultiMailInput = _resolveComponent("MultiMailInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_openBlock(), _createElementBlock("div", {
          class: "modal-body my-2 mx-2",
          key: _ctx.renderKey
        }, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_el_checkbox, {
              modelValue: _ctx.data.sendToCol,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.data.sendToCol) = $event)),
              disabled: 
                !(_ctx.job.contact_on_location && _ctx.job.contact_on_location.email)
              ,
              label: "Contact on location",
              size: "large",
              border: ""
            }, null, 8, ["modelValue", "disabled"]),
            _createVNode(_component_el_checkbox, {
              modelValue: _ctx.data.sendToPM,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.data.sendToPM) = $event)),
              disabled: !(_ctx.job.project_manager && _ctx.job.project_manager.email),
              label: "Crew Handler",
              size: "large",
              border: ""
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _hoisted_7,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.emails, (mail, index) => {
            return (_openBlock(), _createElementBlock("div", { key: mail }, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_MultiMailInput, {
                  class: "w-75",
                  onInput_event: event => _ctx.handleInput(event, index)
                }, null, 8, ["onInput_event"]),
                (index == _ctx.data.emails.length - 1 && _ctx.data.emails.length < 5)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "ms-2 svg-icon svg-icon-2x svg-icon-primary cursor-pointer",
                      onClick: ($event: any) => (_ctx.addNewMail(index))
                    }, _hoisted_11, 8, _hoisted_9))
                  : _createCommentVNode("", true),
                (index != _ctx.data.emails.length - 1)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "ms-2 svg-icon svg-icon-2x svg-icon-primary cursor-pointer",
                      onClick: ($event: any) => (_ctx.deleteMail(index))
                    }, _hoisted_14, 8, _hoisted_12))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.error && index == _ctx.data.emails.length - 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.error), 1))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("button", {
            type: "button",
            disabled: _ctx.loading,
            class: "btn btn-light",
            "data-bs-dismiss": "modal"
          }, " Close ", 8, _hoisted_17),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args))),
            disabled: _ctx.loading,
            type: "button",
            class: "btn btn-primary"
          }, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_19))
              : _createCommentVNode("", true),
            _hoisted_20
          ], 8, _hoisted_18)
        ])
      ])
    ])
  ]))
}